import styled from 'styled-components';

const StyledLogo = styled.div`
  /* cursor: pointer; */
  box-sizing: border-box;
  margin-left: 1rem;
`;
export default StyledLogo;
